/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrsize1Inputs */

const en_qrsize1 = /** @type {(inputs: Qrsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const de_qrsize1 = /** @type {(inputs: Qrsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Qrsize1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrsize1 = /** @type {((inputs?: Qrsize1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrsize1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrsize1(inputs)
	return de_qrsize1(inputs)
});
export { qrsize1 as "qrSize" }